
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quelle est son efficacité?`}</em></p>
    <p>{`Dans un communiqué de presse publié le 22 mars 2021,
`}<a parentName="p" {...{
        "href": "https://www.astrazeneca.com/media-centre/press-releases/2021/astrazeneca-us-vaccine-trial-met-primary-endpoint.html"
      }}>{`AstraZeneca a annoncé une efficacité de 79%`}</a>{`
contre les formes symptomatiques du Covid-19, après deux doses administrées à
quatre semaines d'intervalle. Le Comité de surveillance des données et de la
sécurité américain s'est toutefois inquiété du fait que ces résultats aient pu
inclure des données `}<a parentName="p" {...{
        "href": "165723084685"
      }}>{`"obsolètes"`}</a>{`. Suite à ces critiques, le
laboratoire a revu le 25 mars l'efficacité de son produit à
`}<a parentName="p" {...{
        "href": "https://www.astrazeneca.com/content/astraz/media-centre/press-releases/2021/azd1222-us-phase-iii-primary-analysis-confirms-safety-and-efficacy.html"
      }}>{`76%`}</a>{`
pour éviter les cas symptomatiques. Selon cet essai clinique mené aux Etats-Unis
et en Amérique latine, ce taux est de 85% pour les 65 ans et plus. Le produit
empêche en outre totalement les formes graves de la maladie ainsi que les
hospitalisations.`}</p>
    <p>{`Selon une étude britannique publiée en août 2021,
`}<a parentName="p" {...{
        "href": "https://www.nejm.org/doi/full/10.1056/NEJMoa2108891"
      }}>{`l'efficacité contre l'infection avec le variant Delta`}</a>{`
est de 67%. Des données canadiennes rapportées par AstraZeneca en juillet 2021
concluent à un succès de
`}<a parentName="p" {...{
        "href": "https://www.astrazeneca.com/media-centre/press-releases/2021/vaxzevria-is-highly-effective-after-one-dose-against-severe-disease-or-hospitalisation-caused-by-beta-and-delta-variants-of-concern.html"
      }}>{`87% contre l'hospitalisation, toujours avec le variant Delta`}</a>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;